import { MonSisraApis } from "../apis/monsisra";
import { FileResponse, PreferencesSollicitation, SaisieInfosFacturationSollicitation, TypeSollicitation, TypeUtilisateurSollicitation } from "../apis/monsisra/generated";
import { User } from "../../view/store/auth/auth.types";
import {UserInfo} from "../apis/monsisra/generated.v2";

export class ProfessionnelService {
	async setPreferenceSollicitation(idTechPs: User["idTechPs"], preferences: PreferencesSollicitation) {

		let numeroDemandeurRequis = preferences.preferencesFacturationExpert?.numeroDemandeurRequis ?? false;
		if (preferences.preferencesFacturationExpert?.nir === "Invisibles") {
			numeroDemandeurRequis = false
		}
		return await MonSisraApis.sollicitation.savePreferencesSollicitation(idTechPs, {
			...preferences!,
			// Gestion du placeholder dans le cas ou l'utilisateur ne veut pas utiliser de formulaire
			idTypeFormulaire:
				preferences.centragePatient && preferences.idTypeFormulaire !== "null" ? preferences.idTypeFormulaire : undefined,
			prerequis: preferences.prerequis as any,
			preferencesFacturationExpert: preferences.centragePatient ? {
					numeroDemandeurRequis: numeroDemandeurRequis,
					nir: preferences.preferencesFacturationExpert?.nir || SaisieInfosFacturationSollicitation.Invisibles,
				}
				: undefined,
		});
	}

	async getPreferenceSollicitation(idTechPs: User["idTechPs"], type: TypeSollicitation): Promise<PreferencesSollicitation> {
		const typeUtilisateur =
			type === TypeSollicitation.TeleExpertise ? TypeUtilisateurSollicitation.Expert : TypeUtilisateurSollicitation.EquipeRessource;
		return await MonSisraApis.sollicitation.getPreferencesSollicitation(idTechPs, typeUtilisateur);
	}

	async getPs() {
		return await MonSisraApis.professionnel.getInformationsPSConnecte();
	}

	getPreferenceConfig(type: TypeSollicitation) {
		const typeUtilisateur =
			type === TypeSollicitation.TeleExpertise ? TypeUtilisateurSollicitation.Expert : TypeUtilisateurSollicitation.EquipeRessource;
		return MonSisraApis.sollicitation.getConfigurationPreferencesSollicitation(typeUtilisateur);
	}

	async getFichierSollicitation(idFichierSollicitation: string, typeSollicitation: TypeSollicitation): Promise<FileResponse> {
		const typeUtilisateur =
			typeSollicitation === TypeSollicitation.TeleExpertise ? TypeUtilisateurSollicitation.Expert : TypeUtilisateurSollicitation.EquipeRessource;
		return (await MonSisraApis.sollicitation.getDocumentPrerequisSollicitation(idFichierSollicitation, typeUtilisateur))!;
	}

	async getInfosPs(idTechPsCible: User["idTechPs"]): Promise<UserInfo> {
		return (await MonSisraApis.professionnelV2.getByIdTech(idTechPsCible));
	}

	async getDroitOuvrirIframeTleModeAdmin (idTechPsCible: string, parentUrl: string) {
		return (await MonSisraApis.sollicitation.getDroitOuvrirIframeTleModeAdmin(idTechPsCible, parentUrl));
	}

	async getProfessionsAndSpecialites() {
		return (await MonSisraApis.professionnelV2.getFiltresModuleRechercheOP());
	}
}
